import React, { useState, useEffect } from 'react';
const BG_COLOR = '#F2F0E9';
const BG_TEXTURE = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/intro-section-bg-ukuvealjzb9.png';
const ASSET_URL = "https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmnhj2ahv00de0z0y1cq7bf09/images/agent-ready-2-1-jpl6mx5keo.png";
export const AIStorefrontAgents = () => {
  const [windowWidth, setWindowWidth] = useState(() => typeof window !== 'undefined' ? window.innerWidth : 1440);
  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const isCompact = windowWidth <= 1024;
  return <section id="aisf-agents" data-name="AI Storefront Agents" data-nav-theme="light" style={{
    backgroundColor: BG_COLOR,
    backgroundImage: `url(${BG_TEXTURE})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    paddingTop: 'clamp(60px, 8vw, 120px)',
    paddingBottom: 'clamp(60px, 8vw, 120px)'
  }}>
      <div className="section-content" style={{
      maxWidth: '1360px',
      margin: '0 auto',
      padding: '0 24px'
    }}>

        {/* ── Headline + Description row (mirrors hero) ── */}
        <div style={{
        display: 'flex',
        flexDirection: isCompact ? 'column' : 'row',
        gap: isCompact ? '24px' : '64px',
        alignItems: isCompact ? 'flex-start' : 'flex-end'
      }} className="mb-[44px] mt-0 ml-0 mr-0 pt-0 pb-0 pl-0 pr-0">
          {/* Left: headline */}
          <div style={{
          flex: isCompact ? 'none' : '0 0 58%'
        }}>
            <h2 style={{
            margin: 0,
            lineHeight: 1.05,
            color: '#091717',
            fontSize: 'clamp(52px, 7vw, 92px)',
            fontWeight: 400
          }}>
              <span style={{
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 400
            }}>
                Your store should be ready for{' '}
              </span>
              <span style={{
              fontFamily: 'Instrument Serif, serif',
              fontStyle: 'italic',
              fontWeight: 400,
              letterSpacing: '-0.02em'
            }}>
                agents
              </span>
            </h2>
          </div>

          {/* Right: description */}
          <div style={{
          marginLeft: isCompact ? 0 : 'auto',
          flexShrink: 0,
          paddingBottom: isCompact ? 0 : '6px',
          width: isCompact ? '100%' : 'auto'
        }}>
            <p style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: 'clamp(16px, 1.5vw, 20px)',
            lineHeight: 1.4,
            color: '#091717',
            margin: 0,
            textAlign: 'left'
          }}>
              AI storefront is built for the agents shopping
              <br className="hidden lg:block" />
              on your customers' behalf. Structured,
              <br className="hidden lg:block" />
              readable, and ready to act on.
            </p>
          </div>
        </div>

        {/* ── Full-width asset, natural height ── */}
        <img src={ASSET_URL} alt="Human-facing store and agents-facing store side by side" style={{
        width: '100%',
        height: 'auto',
        display: 'block'
      }} />

      </div>
    </section>;
};